import { useEffect, useState } from "react";
import api from "../../utils/api";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Paper,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function AdminAgentsPage() {
  const [agents, setAgents] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/admin/agents").then((res) => {
      // 🔒 ENFORCE FINANCE INVARIANT AT UI LEVEL
      const normalized = res.data.agents.map((a) => {
        const earned = Number(a.earned_total || 0);
        const paid = Number(a.paid_total || 0);

        return {
          ...a,
          earned_total: earned,
          paid_total: paid,
          available_balance: Math.max(earned - paid, 0), // ✅ derived, not trusted
        };
      });

      setAgents(normalized);
    });
  }, []);

  return (
    <Box p={3}>
      <Typography variant="h5" gutterBottom>
        Agents
      </Typography>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Agent</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Students</TableCell>
              <TableCell>Earned (₦)</TableCell>
              <TableCell>Available (₦)</TableCell>
              <TableCell>Paid (₦)</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>

          <TableBody>
            {agents.map((a) => (
              <TableRow key={a.agent_id}>
                <TableCell>{a.agent_name}</TableCell>
                <TableCell>{a.agent_email}</TableCell>
                <TableCell>{a.total_students}</TableCell>

                <TableCell>
                  {a.earned_total.toLocaleString()}
                </TableCell>

                <TableCell>
                  {a.available_balance.toLocaleString()}
                </TableCell>

                <TableCell>
                  {a.paid_total.toLocaleString()}
                </TableCell>

                <TableCell>
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={() =>
                      navigate(`/admin/agents/${a.agent_id}`)
                    }
                  >
                    View
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
